import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { ConfigurationPossibleAssayResultPatchInBatchRequest, ConfigurationPossibleAssayResultRequest, ConfigurationPossibleAssayResultResponse } from '@/modules/configurationModule/detail/local-assays/results/services/configuration-possible-assay-result/configuration-possible-assay-result.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationPossibleAssayResultService {
    async create(laboratoryId: number, request: ConfigurationPossibleAssayResultRequest): Promise<ConfigurationPossibleAssayResultResponse> {
        const response = await axios.post<ConfigurationPossibleAssayResultResponse>(`/configuration/laboratories/${laboratoryId}/possibleAssayResult`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationPossibleAssayResultResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPossibleAssayResultResponse>>(`/configuration/laboratories/${laboratoryId}/possibleAssayResult`, { ...filterModel }, { params })
        return response.data
    }

    async get(possibleAssayResultId: number, laboratoryId: number): Promise<ConfigurationPossibleAssayResultResponse> {
        const response = await axios.get<ConfigurationPossibleAssayResultResponse>(`/configuration/laboratories/${laboratoryId}/possibleAssayResult/${possibleAssayResultId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/possibleAssayResult/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationPossibleAssayResultPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/possibleAssayResult/batch`, request)
        return response.data
    }
}

export const configurationPossibleAssayResultService = new ConfigurationPossibleAssayResultService()
